export default __webpack_public_path__ + "static/0269-9c7398d5b6be2b591d7a09a1534357c5.png";